//* MUI imports
import { Box, Typography } from '@mui/material';

export const InputFieldDocs = () => {
  const styles = {
    root: {},
  };

  return (
    <Box sx={styles.root}>
      <Box>
        <Typography variant="h3">Time Picker</Typography>
        {/* <TimePicker /> */}
      </Box>
    </Box>
  );
};
